<template>
  <div class="flex gap-3 items-center">
    <!-- <div class="w-14 md:w-16 aspect-square border rounded-md relative bg-white" @click="user.toggleFavorite(team)" :class="{ 'pointer-events-none': isFavorite, 'cursor-pointer': !isFavorite }">
      <TeamLogo class="block w-full h-full" :name="team.name" :slug="team.slug" :logo="team.logo" size="128" :alt="team.abbr" />
      <div class="absolute -bottom-1 -right-1" v-if="!isFavorite">
        <button class="border rounded-full p-1.5 bg-white">
          <AtomIcon name="heart-circle-plus" class="text-red-600 text-lg" />
        </button>
      </div>
    </div> -->
    <div class="-mt-0.5">
      <div class="font-heading font-bold text-3xl md:text-4xl">{{ heading }}</div>
      <h1 class="text-sm text-slate-500" v-html="leading" />
    </div>
  </div>
</template>

<script setup>
const { t } = useI18n()
const route = useRoute()
// const user = useUserStore()
const team = useTeamStore()
// const isFavorite = computed(() => user?.favoriteIds.includes(team.id))

const headingKeyMap = {
  'team': 'pages.team.heading',
  'team-fixtures': 'pages.fixtures.heading',
  'team-fixtures-home': 'pages.fixturesHome.heading',
  'team-fixtures-away': 'pages.fixturesAway.heading',
  'team-results': 'pages.results.heading',
  'team-results-home': 'pages.resultsHome.heading',
  'team-results-away': 'pages.resultsAway.heading',
  'team-table': 'pages.table.heading',
  'team-table-home': 'pages.tableHome.heading',
  'team-table-away': 'pages.tableAway.heading',
  'team-statistics': 'pages.statistics.heading',
}

const leadingKeyMap = {
  'team': 'pages.team.leading',
  'team-fixtures': 'pages.fixtures.leading',
  'team-fixtures-home': 'pages.fixturesHome.leading',
  'team-fixtures-away': 'pages.fixturesAway.leading',
  'team-results': 'pages.results.leading',
  'team-results-home': 'pages.resultsHome.leading',
  'team-results-away': 'pages.resultsAway.leading',
  'team-table': 'pages.table.leading',
  'team-table-home': 'pages.tableHome.leading',
  'team-table-away': 'pages.tableAway.leading',
  'team-statistics': 'pages.statistics.leading',
}

const params = {
  textFixtures: t('shared.nav.fixtures'),
  textResults: t('shared.nav.results'),
  textTable: t('shared.nav.table'),
}

const heading = computed(() => {
  const key = headingKeyMap[route.name]
  return key ? t(key, { teamName: team.name, seasonYear: team.season?.year, ...params }) : ''
})

const leading = computed(() => {
  const key = leadingKeyMap[route.name]
  return key ? t(key, { teamName: team.name, seasonYear: team.season?.year, ...params }) : ''
})
</script>
